import { render, staticRenderFns } from "./sendPackage.vue?vue&type=template&id=04b26e3e&scoped=true&"
import script from "./sendPackage.vue?vue&type=script&lang=js&"
export * from "./sendPackage.vue?vue&type=script&lang=js&"
import style0 from "./sendPackage.vue?vue&type=style&index=0&id=04b26e3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b26e3e",
  null
  
)

export default component.exports